import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DialogConfiguration } from '../interfaces/dialog-configuration.interface';

@Component({
  selector: 'app-carousel-documents',
  templateUrl: './carousel-documents.component.html',
  styleUrls: ['./carousel-documents.component.scss'],
})
export class CarouselDocumentsComponent implements OnInit {
  public images: any;
  public viewImage!: string;
  public creditType!: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogConfiguration,
    public dialogReference: MatDialogRef<CarouselDocumentsComponent>
  ) {}

  ngOnInit(): void {
    this.images = this.data.documents!;
    this.viewImage = this.images[0].url;
    this.creditType = this.data.question;
  }

  clickViewImage(image: string) {
    this.viewImage = image;
  }
}
